
export const config = {
  apiUrl: import.meta.env.VITE_NAV_API_URL,
  kraftvynUrl: import.meta.env.VITE_KRAFTVYN_URL,
  isDevelopment: import.meta.env.VITE_IS_DEV == "true",
};
